import { useState, useEffect } from 'react';
import { fetchJson } from '../components/services/league-standings-services';

export const useIsDefConLive = (): boolean => {
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const { id: gw } = await fetchJson<{ id: number }>('/api/current-gameweek');
        const fixtures = await fetchJson<any[]>(`/api/${gw}/fixtures`);
        setIsLive(fixtures.some(f => f.started && !f.finished && !f.finished_provisional));
      } catch {
        // silently ignore
      }
    };
    check();
  }, []);

  return isLive;
};
